module.exports = __webpack_public_path__ + "static/media/default_user_image.724ca1c7.png";